import Crops from "./Crops";
import GeoAI from "./GeoAI";
import Prints from "./Prints";
import APIUsages from "./APIUsages";
import styled from "styled-components";
import React, { useState } from "react";
import SidebarHeader from "../layout/SidebarHeader";

const Wrapper = styled.div`
  margin: 15px 0;
  padding: 1rem 0;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;

  label {
    font-size: 10px;
  }

  input {
    font-size: 14px !important;
  }
`;

const Tabs = styled.div`
  display: flex;
  margin-bottom: 30px;

  button {
    padding-bottom: 5px;
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    font-family: Roboto;
    color: #a0a0a0;
    outline: none;

    &:not(:first-child) {
      margin-left: 22px;
    }

    &.active {
      color: #e5e5e5;
      border-bottom: solid 2px #487bf2;
    }
  }
`;

const SidebarDashboard = ({ onClose }) => {
  const [tab, setTab] = useState("crops");

  return (<>
    <SidebarHeader onClose={onClose} />
    <div style={{ fontSize: 24, color: 'white' }}>Dashboard</div>
    <Wrapper>
      <Tabs>
        <button
          className={tab === "crops" ? "active" : null}
          onClick={() => setTab("crops")}
        >
          Crops
        </button>
        <button
          className={tab === "prints" ? "active" : null}
          onClick={() => setTab("prints")}
        >
          Prints
        </button>
        <button
          className={tab === "storage" ? "active" : null}
          onClick={() => setTab("storage")}
        >
          Storage
        </button>
        <button
          className={tab === "apiUsages" ? "active" : null}
          onClick={() => setTab("apiUsages")}
        >
          API Usage
        </button>
        <button
          className={tab === "geoaiUsages" ? "active" : null}
          onClick={() => setTab("geoaiUsages")}
        >
          GeoAI Usage
        </button>
      </Tabs>
      {tab == "crops" && <Crops />}
      {tab == "prints" && <Prints />}
      {tab == "apiUsages" && <APIUsages />}
      {tab == "geoaiUsages" && <GeoAI />}
    </Wrapper>
  </>)
}
export default SidebarDashboard;